import { defineComponent as _defineComponent } from 'vue'
import { ref, withDefaults } from '../../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import Overlay from '../../../../common/Overlay/index.vue';
import Drawer from '../../../../common/Drawer/index.vue';
import SimpleMessageList from '../simple-message-list/index.vue';
import { isH5, isPC, isUniFrameWork } from '../../../../../utils/env';
import { transformTextWithKeysToEmojiNames } from '../../../emoji-config/index';
import { IMergeMessageContent } from '../../../../../interface';

interface IEmits {
  (e: 'assignMessageIDInUniapp', messageID: string): void;
}

interface IProps {
  // Core data for rendering message record card and message list
  renderData: IMergeMessageContent;
  /**
   * The MessageRecord component has two main functions:
   * 1. display message record cards primarily.
   * 2. clicking on it and show the simple message list.
   * When used as a nested component with the disabled prop
   * it is only need renderData to render message record cards.
   * Therefore, 'messageItem' and 'disabled' is not a required prop.
   */
  disabled?: boolean;
  messageItem?: IMessageModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    renderData: null,
    disabled: { type: Boolean, default: false },
    messageItem: { default: () => ({}) as IMessageModel }
  },
  emits: ["assignMessageIDInUniapp"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'assignMessageIDInUniapp', messageID: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { renderData: IMergeMessageContent, disabled: boolean, messageItem: IMessageModel }




const isMessageListVisible = ref(false);

function openMergeDetail() {
  if (props.disabled) {
    return;
  }
  if (!isUniFrameWork) {
    isMessageListVisible.value = true;
  } else {
    emits('assignMessageIDInUniapp', props.messageItem.ID);
  }
}

function closeMergeDetail() {
  isMessageListVisible.value = false;
}

return { __sfc: true,emits, props, isMessageListVisible, openMergeDetail, closeMergeDetail, TUITranslateService, Overlay, Drawer, SimpleMessageList, isH5, isPC, isUniFrameWork, transformTextWithKeysToEmojiNames }
}

})